import { Input } from "@kovernow/react-ui/components/input";
import { Label } from "@kovernow/react-ui/components/label";
import { useId, type ComponentProps, type ReactNode } from "react";

/**
 * Labelled input. Errors use aria-describedby + aria-invalid; hints (e.g.
 * password rules) are shown up front and also described.
 */
export function FormField({
  label,
  error,
  hint,
  trailing,
  ...input
}: ComponentProps<"input"> & { label: string; error?: string; hint?: string; trailing?: ReactNode }) {
  const id = useId();
  const hintId = hint ? `${id}-hint` : undefined;
  const errorId = error ? `${id}-error` : undefined;
  return (
    <div className="flex flex-col gap-1.5">
      <Label htmlFor={id}>{label}</Label>
      {hint ? (
        <p id={hintId} className="text-sm text-muted-foreground">
          {hint}
        </p>
      ) : null}
      <div className="flex items-center gap-2">
        <Input
          id={id}
          className="min-h-11 border-input"
          aria-invalid={error ? true : undefined}
          aria-describedby={[hintId, errorId].filter(Boolean).join(" ") || undefined}
          {...input}
        />
        {trailing}
      </div>
      {error ? (
        <p id={errorId} className="text-sm font-semibold text-status-error">
          {error}
        </p>
      ) : null}
    </div>
  );
}
